import { defineComponent as _defineComponent } from 'vue'
import BButton from 'JS/components/BButton.vue';
import HeaderDropMenu from '../HeaderDropMenu.vue';
import Icon from 'JS/components/Icon.vue';
import LinkButton from 'JS/components/LinkButton.vue';
import { computed, PropType } from 'vue';
import { IHeaderJson } from 'Src/js/types/Header';


export default /*#__PURE__*/_defineComponent({
  __name: 'HeaderAccount',
  props: {
	headerData: { type: Object as PropType<IHeaderJson>, required: true },
	customerName: { type: String, required: false, default: '' },
},
  setup(__props) {

const props = __props



const logoutLink = computed((): string => {
	const path = `/account/logout/`;
	if (typeof window === 'undefined' || window.location?.pathname === '/') return path;
	return `${path}?refUrl=${encodeURIComponent(window.location.pathname)}`;
});

const registryLink = computed((): string => {
	return props.headerData.customer?.customerHasRegistries
		? '/gift-registry/list/'
		: '/gift-registry/';
});

function showLoginSideMenu(page: 'login' | 'create', url?: string) {
	Blain.Login.showSideMenu(page, true, url || null);
}

function handleGuestAccountLink(e: Event) {
	if (props.headerData.loggedIn) return;
	e.preventDefault();
	showLoginSideMenu('login', (e.target as HTMLElement).getAttribute('href'));
}

return { __sfc: true,props, logoutLink, registryLink, showLoginSideMenu, handleGuestAccountLink, BButton, HeaderDropMenu, Icon, LinkButton }
}

})